export const useAbsoluteUnits = (): boolean => {
    return (
        (typeof document !== "undefined" && document.cookie.indexOf("absoluteUnit=") !== -1) ||
        (typeof window !== "undefined" && window.matchMedia && window.matchMedia("print").matches)
    );
};

export default useAbsoluteUnits;
